<template>
  <div>
    <SkipTo />
    <Menu />
    <main id="main" tabindex="-1">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import SkipTo from "@/components/SkipTo.vue";
import Menu from "@/components/Menu.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    SkipTo,
    Menu,
    Footer
  }
};
</script>
